import { createStore as _createStore } from 'vuex'
import modules from './modules'
import orm from './models'

const store = _createStore({
  modules,
  strict: process.env.NODE_ENV !== 'production',
  plugins: [orm],
})

export default store
